module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-arrow_b-a59f1347ebfc5c128ae0e38e1d884ce3.png";